/* Package JSON Import will be here */
import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

/* Package JSON Import will be here */
class AuthenticateRoute extends Route {
    render() {
        if (this.props.device && this.props.user && this.props.device.isDeviceAlreadyRegistered && this.props.device.deviceFingerPrintId && this.props.user.loggedIn
            // For now, Commenting out. We will uncomment once Claims are implemented for Employee Role
            // this.props.user.roleName && this.props.authorizedClaim && this.props.user.claimValue.includes(this.props.authorizedClaim)
        ) {
            return (
                <Route component={this.props.component} path={this.props.path} />
            );
        }
        else {
            return (
                <Redirect to={{ pathname: '/' }} />
            );
        }
    }

}
function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

export default connect(mapStateToProps)(AuthenticateRoute);